import { render, staticRenderFns } from "./LocalePicker.vue?vue&type=template&id=6b4a0b4e&scoped=true&lang=html&"
import script from "./LocalePicker.vue?vue&type=script&lang=js&"
export * from "./LocalePicker.vue?vue&type=script&lang=js&"
import style0 from "./LocalePicker.vue?vue&type=style&index=0&id=6b4a0b4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4a0b4e",
  null
  
)

export default component.exports